import React, { useState } from 'react';
import { Input, Button, Modal, Form } from 'antd';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-github';

const { TextArea } = Input;

export const InstructionEditor = ({content, formRef}) => {
  const [text, setText] = useState(content);
  const [visible, setVisible] = useState(false);
  const [editorContent, setEditorContent] = useState('');

  const handleOpenEditor = () => {
    setEditorContent(text);
    setVisible(true);
  };

  const handleSave = () => {
    setText(editorContent);
    formRef.setFieldValue("values", editorContent);
    setVisible(false);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
      <Form.Item
        name={"values"}
        initialValue={text}
        style={{ flex: 1 }}
      >
        <TextArea
          onChange={(e) => setText(e.target.value)}
          rows={8}
          readOnly={true}
        />
      </Form.Item>
      <Button 
          type="primary" 
          onClick={handleOpenEditor}
          style={{ marginTop: '4px' }}
        >
        Edit
      </Button>
      <Modal
        title="Instruction"
        visible={visible}
        width={'70%'}
        onOk={handleSave}
        onCancel={() => setVisible(false)}
        okText="Save"
        cancelText="Cancel"
        destroyOnClose
        styles={{
          body: { 
            height: '70vh',
            overflowY: 'scroll' 
          }
        }}
      >
        <AceEditor
          mode="javascript"
          theme="github"
          value={editorContent}
          onChange={setEditorContent}
          name="code-editor"
          editorProps={{ $blockScrolling: true }}
          width="100%"
          height="100%"
          fontSize={14}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 2,
          }}
        />
      </Modal>
    </div>
  );
};